<template>
  <div
    class="ll-title-with-button-card"
    :class="{'border-bottom':hasBorderBottom}"
  >
    <div class="ll-title-with-button-card__title-wrap">
      <p class="ll-title-with-button-card__title">
        {{ title }}
      </p>
      <div class="ll-title-with-button-card__btns">
        <div
          v-for="(btn,btnIndex) in buttonList"
          :key="btnIndex"
          class="ll-title-with-button-card__btn"
        >
          <WsButton001
            v-if="btn.type === 'ArcButton'"
            out-line
            width-stretch
            flat-button
            @click="$_onClick(btn.value)"
          >
            {{ btn.text }}
          </WsButton001>
          <WsButton001
            v-if="btn.type === 'GradientButton'"
            width-stretch
            flat-button
            @click="$_onClick(btn.value)"
          >
            {{ btn.text }}
          </WsButton001>
        </div>
      </div>
    </div>
    <div class="ll-title-with-button-card__content">
      <slot />
    </div>
  </div>
</template>
<script>
export default {
  name: "LlTitleWithButtonCard",
  props: {
    title: {
      type: String,
      default: "",
    },
    buttonList: {
      type: Array,
      default() {
        return [];
      },
    },
    hasBorderBottom: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    $_onClick(value) {
      this.$emit(`${value}`);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/component/ll-title-with-button-card";
</style>